export default __webpack_public_path__ + "locales/vi/DataReassignmentDialog.json?hash=aea6251554582b716c2bc24d74b788c0";